@if (error !== '' || success !== '') {
  <mat-card class="mb-m p-m">
    @if (success !== '') {
      <p>
        {{ success }}
      </p>
    }
    @if (error !== '') {
      <p>
        {{ error }}
      </p>
    }
  </mat-card>
}

<form [formGroup]="pageForm" class="d-flex jcsb">
  <div class="w-70 flex-column d-flex mt-l">
    <input type="hidden" formControlName="id"/>
    <mat-form-field appearance="outline" class="full-field">
      <mat-label>Page Title</mat-label>
      <input matInput formControlName="page_title"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Url</mat-label>
      <input matInput formControlName="relative_url"/>
    </mat-form-field>
    <p>Link: <a [href]="win.location.protocol + '//' + win.location.host + (pageForm.value.public ? '/open/page/' + pageForm.value.relative_url : '/page/' + pageForm.value.relative_url)" target="_blank">{{win.location.protocol}}//{{win.location.host}}/{{pageForm.value.public ? "open/page/" : "page/"}}{{pageForm.value.relative_url}}</a></p>

    <div class="editor">
      <mat-label class="mb-l">Content</mat-label>
      <editor licenseKey="gpl" [init]="editor"
              formControlName="content"
              plugins="visualblocks link code searchreplace lists advlist table autoresize importcss image">
      </editor>
    </div>
  </div>
  <div class="w-30 flex-column d-flex pl-l">
    <h2>Settings</h2>
    <mat-form-field appearance="outline" class="full-field">
      <mat-label>Navigation Title</mat-label>
      <input matInput formControlName="nav_title"/>
    </mat-form-field>
    <div class="py-m">
      <mat-slide-toggle formControlName="show_title" color=primary>Show Title</mat-slide-toggle>
    </div>
    <div class="py-m">
      <mat-slide-toggle formControlName="published" color=primary>Published</mat-slide-toggle>
    </div>
    <div class="py-m">
      <mat-slide-toggle formControlName="public" color=primary>Is public</mat-slide-toggle>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Back Link</mat-label>
      <input matInput formControlName="back_link"/>
    </mat-form-field>
    <div class="image-area w-100 my-m">
      @if (bannerImage) {
        <img src="{{bannerImage}}" alt="{{pageTitle}}" class="w-100"/>
      } @else {
        <div class="p-m"></div>
      }
    </div>
    <div class="actions d-flex jcsb">
      <button mat-stroked-button class="mb-l" (click)="deleteImage('banner')">Delete Banner Image</button>
      <button mat-flat-button class="mb-l" (click)="uploadImage(tile, 'banner')">Upload Banner image</button>
    </div>
    <div class="image-area p-m w-90 my-m">
      @if (tile) {
        <img src="{{tile}}" alt="{{pageTitle}}"/>
      } @else {
        <div class="p-m"></div>
      }
    </div>
    <div class="actions d-flex jcsb">
      <button mat-stroked-button class="mb-l" (click)="deleteImage('tile')">Delete Tile Image</button>
      <button mat-flat-button class="mb-l" (click)="uploadImage(tile, 'tile')">Upload Tile image</button>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput formControlName="start_date" type="date"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput formControlName="end_date" type="date"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Authorities</mat-label>
      <mat-select formControlName="authorities" multiple>
        @for (authories of authorities; track authories) {
          <mat-optgroup [label]="authories.label">
            @for (authority of authories.authorities | keyvalue; track authority) {
              <mat-option [value]="authority.key">
                {{ authority.value }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>
    <button mat-flat-button color="primary" (click)="savePage()">Speichern</button>
  </div>
</form>
